<template>
	<div>
		<head-nav></head-nav>
		<div class="">
			<div class="clearfix">
				<div class="shopping-button">
					<b-button class="btn btn-dark boton-library" @click="toLibrary" style="	font-family: 'belerno';"><i
							class="el-icon-shopping-bag-1" style="color: #fff; "></i>
						({{ library.length }}) View Cart
					</b-button>
					<el-dropdown>
						<span class="el-dropdown-link">
							<img src="../img/user.png" style="padding: 6px 0px" width="30" />
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<router-link style="color: #000" to="/change-password">Change Password</router-link>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<b-button class="btn btn-light" size="sm" @click="logout" exact>
						<img src="../img/home.png" width="35" />
					</b-button>
				</div>
			</div>
			<div class="container-kiosk">
<!-- 				<div>
					<p>My issues</p>
					<hr>
						<div class="d-flex">
							<div class="cards">
								<div>
									<img style="width: 200px;"
										src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/covers%2Fissue1.png?alt=media&token=4a8c268f-6762-484f-9548-269358a5acf0"
										alt="issue.alt" />
								</div>
							</div>
							<div class="cards">
								<div>
									<img style="width: 200px;"
										src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/covers%2Fissue5.png?alt=media&token=5baa4138-248a-4ee6-b68f-379a7f7f33b1" />
								</div>
							</div>
							<div class="cards">
								<div>
									<img style="width: 200px;"
										src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/covers%2Fissue10.png?alt=media&token=5fe9946a-da2b-402d-9404-f917361af468" />
								</div>
							</div>
						</div>
				</div> 

				<p>Kiosko</p>
				<hr>-->
				<div class="container-grid">
					<div class="cards" v-for="(issue, index ) in coverArray" v-bind:key="index">
						<div class="image6">
							<img class="img-content" :src="issue.cover" :alt="issue.alt" />
							<img :src="issue.blurb" :alt="issue.alt" class="img-text" />
						</div>
						<div class="mt-2">
							<div>
								<!-- <button @click="watchCov(issue.version, issue.to )" class="btn btn-dark" >Read</button> -->
								<button class="btn btn-dark" v-if="validateAssets(issue.issue.prodId)"
									@click="watchCov(issue.version, issue.to)">Read</button>
								<button v-else @click="addTo(issue.issue)" class="btn btn-dark">Buy</button>
							</div>
							<div class="mt-2">
								<h6>{{ issue.name }}</h6>
							</div>
							<div class="mb-2">
								<span style="font-family:berleno">Price: ${{ issue.price }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<info></info>
		</div>
		<foot-miss></foot-miss>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import covers from "../assets/covers.json"
import { auth, db } from '@/firebase';
import info from "./info";
import footMiss from "./footer";
import headNav from "./navBar";
export default {
	name: "kiosko",
	components: {
		headNav,
		info,
		footMiss
	},
	data() {
		return {
			coverArray: [],
			issues:[]
		};
	},
	async created() {
		this.coverArray = covers
		await this.getUserIssues()
		
		//this.setVal(this.issues)
		setTimeout(() => {
			this.validateLibrary(this.issues);
		}, 100);
	},
	mounted() {
		

	},
	methods: {
		watchCov(cover = null, to) {
			this.verCover(cover)
			this.$router.push(to);
		},
		logout() {
			try {
				localStorage.clear()
				auth.signOut();
				this.$router.push("/the-magazine");// Redirige al login u otra página
			} catch (error) {
				console.error('Error logging out:', error);
			}
		},
		async getUserIssues() {
			try {
				const user = auth.currentUser;

				if (user) {
					const issueList = await db.collection('users').doc(user.uid).collection('access').get();

					// Extraer todos los documentos en un array de issues
					this.issues = issueList.docs.map(doc => ({
						id: doc.id,
						...doc.data(),
					}));

					// Extraer el array de prodId de cada documento
					const prodIds = issueList.docs.map(doc => doc.data().prodId);
					this.$store.commit("issues", prodIds);
				} else {
					console.error('No hay usuario autenticado');
				}
			} catch (error) {
				console.error('Error obteniendo issues:', error);
			}
		},
		...mapMutations("cart", ["addLibrary", "validateLibrary"]),
		...mapMutations("inPlayer", ["assets", "setValidateAssets", "setVal"]),
		...mapMutations("magazine", ["verCover"]),

		addTo(issue) {
			this.addLibrary(issue);
			swal({
				title: "Great!",
				icon: "success",
				text: `${issue.name} was just added to your cart`,
				buttons: false,
				timer: 3000,
			})
		},
		toLibrary() {
			this.$router.push("/cart");
		},

		/* validate if ytou have access to de issue*/
		validateAssets(productId) {
			return this.issues.some( item =>item.prodId === productId);
			
		},

	},
	computed: {

		...mapState("inPlayer", ["pay", "magAssets", "accessAssets", "assetVal"]),
		...mapState("cart", ["library", "issue1", "issue2", "issue3", "issue4", "issue5", "issue6", "issue7", "issue8", "issue9", "issue10", "issue11","issue12"]),
	},
};
</script>

<style lang="scss">
.container-kiosk {
	max-width: 1535px;
	margin: auto;
}

.container-grid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
}

@media (max-width: 768px) {
	.container-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}
}

@media (max-width: 425px) {
	.container-grid {
		display: grid;
		grid-template-columns: 1fr;
	}
}

.cards {
	font-family: 'berleno';
	padding: 1.5rem;
}

.image6 {
	position: relative;

	.img-content {
		width: 100%;
	}

	.img-text {
		display: none;
		width: 100%;
		position: absolute;
		cursor: context-menu;
	}

	&:hover .img-text {
		display: block;
		position: absolute;
		bottom: 0;
	}

}

.shopping-button {
	margin: 1rem 2rem;
	float: right;
}

.boton-library {
	margin-left: -5%;
	margin-right: 5%;
}
</style>
